import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import ListaPerfisView from '@/views/perfis/ListaPerfisView.vue'
import PerfilFormView from '@/views/perfis/PerfilFormView.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'perfis',
      name: 'perfis',
      component: ListaPerfisView,
      meta: { 
        requiresAuth: true,
        nome_fisico: 'perfis' 
      },
    },
    {
      path: 'perfis/form/:id?',
      name: 'PerfilUsuarioForm',
      component: PerfilFormView,
      meta: { 
        requiresAuth: true,
        nome_fisico: 'perfis' 
      },
    },
  ],
}
